<template>
  <section id="add-customer">
    <v-row class="d-flex justify-center" no-gutters>
      <v-col cols="12" md="10" lg="10">
        <page-header
          class="mb-8"
          :breadcrumbs="breadcrumbs"
          :title="$dictionary.app.customers.create.title"
        ></page-header>
        <v-card class="transparent" flat>
          <add-customer-form></add-customer-form>
        </v-card>
      </v-col>
    </v-row>
  </section>
</template>
<script>
import { PageHeader } from "@/components/shared";
import { AddCustomerForm } from "@/components/forms";

/**
 * Add customer view
 */
export default {
  name: "AddCustomer",
  /**
   * --------- Components -----------
   */
  components: {
    PageHeader,
    AddCustomerForm,
  },
  /**
   * ---------------- Computed properties -------------
   */
  computed: {
    /**
     * Add customer page breadcrumbs
     * @type {Array}
     */
    breadcrumbs() {
      return [
        {
          title: this.$dictionary.app.customers.index.title,
          type: this.$appConfig.breadcrumbs.types.route,
          to: this.$paths.customers,
        },
        {
          title: this.$dictionary.app.customers.create.title,
          type: this.$appConfig.breadcrumbs.types.route,
        },
      ];
    },
  },
};
</script>
